import { render, staticRenderFns } from "./PapercleanConfigurazioneGruppiListComponent.vue?vue&type=template&id=6032d0cb"
import script from "./PapercleanConfigurazioneGruppiListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneGruppiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports